import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@core/environments/environment';
import { LoadingService } from './loading.service';
import { finalize } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignatoryService {
  http = inject(HttpClient);
  private loadingService = inject(LoadingService);
  BASE_URL = environment.ADMIN_BASE_URL + '/v1/account';

  // removeUserFromAccount(userId: string, accountId: string) {
  //   return this.http.post(`${this.BASE_URL}/remove-user-from-account`, {
  //     profile_id: userId,
  //     account_id: accountId,
  //   });
  // }

  deactivateSignatory(signatoryId: string, accountId: string) {
    return this.http.post(`${this.BASE_URL}/make-deactivate-account-signatory-request`, {
      signatory_id: signatoryId,
      account_id: accountId,
    });
  }

  makeUpdateSignatoryRequest(payload: {
    first_name?: string;
    last_name?: string;
    email?: string;
    signatory_class?: string;
    account_id: string;
    signatory_id?: string;
    requested_by?: string;
  }) {
    const uniqueStateUrl = 'make-update-account-signatory-request';
    this.loadingService.setLoading(uniqueStateUrl, true);
    return this.http
      .post(`${this.BASE_URL}/make-update-account-signatory-request`, payload)
      .pipe(
        finalize(() =>
          this.loadingService.setLoading(uniqueStateUrl, false)
        )
      );
  }
}
